"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualConfig = exports.Config = void 0;
var shared_1 = require("@cian/peperrors/shared");
var matcher_1 = require("../matcher");
var sources_1 = require("../sources");
var ContextualTransformer_1 = require("../transformers/ContextualTransformer");
var Config = /** @class */ (function () {
    function Config(_a) {
        var source = _a.source, matcher = _a.matcher, transformer = _a.transformer;
        this.transformers = [];
        this.sources = Array.isArray(source) ? source : [source];
        this.matcher = matcher || new matcher_1.Matcher();
        if (transformer) {
            this.transformers = Array.isArray(transformer) ? transformer : [transformer];
        }
    }
    Config.prototype.attach = function (context) {
        return new ContextualConfig({
            context: __assign({}, context),
            source: this.sources.slice(),
            matcher: this.matcher,
            transformer: this.transformers.slice(),
        });
    };
    Config.prototype.get = function (key, context) {
        var setting = this.find(key, context);
        return setting && setting.value;
    };
    Config.prototype.getStrict = function (key, context) {
        var setting = this.find(key, context);
        if (setting === null) {
            throw new shared_1.NotFoundError({
                message: "Setting '".concat(key, "' is missing in the config!"),
                domain: 'config.getStrict',
            });
        }
        return setting.value;
    };
    Config.prototype.has = function (key, context) {
        return this.find(key, context) !== null;
    };
    Config.prototype.dump = function (keys) {
        var _this = this;
        if (!keys) {
            return this.sources.reduce(function (result, source) {
                result.push.apply(result, __spreadArray([], __read(source.selectAll()), false));
                return result;
            }, []);
        }
        var dumpKeys = Array.isArray(keys) ? keys : [keys];
        return dumpKeys.reduce(function (result, key) {
            var e_1, _a;
            try {
                for (var _b = __values(_this.sources), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var source = _c.value;
                    result.push.apply(result, __spreadArray([], __read(source.selectAll(key)), false));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return result;
        }, []);
    };
    Config.prototype.dumpForContext = function (keys, context) {
        var _this = this;
        var dumpKeys = Array.isArray(keys) ? keys : [keys];
        return dumpKeys.reduce(function (result, key) {
            var setting = _this.find(key, context);
            if (setting) {
                result.push(setting);
            }
            return result;
        }, []);
    };
    Config.prototype.find = function (key, context) {
        var e_2, _a;
        var _this = this;
        var findedSetting = null;
        var settingFilter = function (setting) {
            return _this.matcher.matches(setting, context);
        };
        try {
            for (var _b = __values(this.sources), _c = _b.next(); !_c.done; _c = _b.next()) {
                var source = _c.value;
                var setting = source.select(key, settingFilter);
                if (!setting) {
                    continue;
                }
                if (!findedSetting || findedSetting.priority < setting.priority) {
                    findedSetting = setting;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return this.settingTransform(findedSetting);
    };
    Config.prototype.settingTransform = function (setting) {
        if (!this.transformers.length || !setting) {
            return setting;
        }
        return this.transformers.reduce(function (result, transformer) {
            return transformer.transform(result);
        }, setting);
    };
    return Config;
}());
exports.Config = Config;
var ContextualConfig = /** @class */ (function (_super) {
    __extends(ContextualConfig, _super);
    function ContextualConfig(props) {
        var _this = _super.call(this, props) || this;
        var context = props.context;
        _this.context = props.context;
        _this.contextualSource = new sources_1.SortedWritableSource();
        _this.sources.push(_this.contextualSource);
        _this.contextualTransformer = new ContextualTransformer_1.ContextualTransformer(context);
        return _this;
    }
    ContextualConfig.prototype.attach = function (context) {
        return _super.prototype.attach.call(this, __assign(__assign({}, this.context), context));
    };
    ContextualConfig.prototype.get = function (key) {
        return _super.prototype.get.call(this, key, this.context);
    };
    ContextualConfig.prototype.getStrict = function (key) {
        return _super.prototype.getStrict.call(this, key, this.context);
    };
    ContextualConfig.prototype.has = function (key) {
        return _super.prototype.has.call(this, key, this.context);
    };
    ContextualConfig.prototype.dumpForContext = function (keys) {
        return _super.prototype.dumpForContext.call(this, keys, this.context);
    };
    ContextualConfig.prototype.injectSettings = function (settings) {
        return this.contextualSource.add(settings);
    };
    ContextualConfig.prototype.settingTransform = function (setting) {
        var superTransformed = _super.prototype.settingTransform.call(this, setting);
        return superTransformed && this.contextualTransformer.transform(superTransformed);
    };
    return ContextualConfig;
}(Config));
exports.ContextualConfig = ContextualConfig;
//# sourceMappingURL=config.js.map